import { apiClient } from './client'
import type { ClientCategory, RequestStatus, RequestItemStatus } from './types'

export interface QuoteSummaryItem {
  id: string
  sourceType: string
  supplierName: string
  procurementUserName: string
  procurementUserId: string
  // null — квота-«заготовка»: BOM скачан, поставщик ещё не ответил.
  price: number | null
  currency: string
  priceCny: number | null
  note: string | null
  createdAt: string
  isMin: boolean
  isSelected: boolean
}

export interface QuotesSummaryPosition {
  id: string
  index: number
  partNumber: string
  brand: string | null
  quantity: number
  matrix: string | null
  status: RequestItemStatus
  selectedQuoteId: string | null
  quotes: QuoteSummaryItem[]
}

export interface QuotesSummaryResponse {
  request: {
    id: string
    requestNumber: string
    clientId: string
    clientName: string
    clientCategory: ClientCategory
    status: RequestStatus
    deadline: string | null
    createdAt: string
    managerName: string
    positionsCount: number
    matrices: string[]
  }
  summary: {
    total: number
    selected: number
    waiting: number
    noQuotes: number
  }
  positions: QuotesSummaryPosition[]
  hasProcurementItems: boolean
}

export async function getQuotesSummary(requestId: string): Promise<QuotesSummaryResponse> {
  const res = await apiClient.get<{ success: true; data: QuotesSummaryResponse }>(
    `/requests/${requestId}/quotes-summary`,
  )
  return res.data.data
}

export interface SaveQuotesSelectionDto {
  selections: Array<{ positionId: string; quoteId: string | null }>
}

export async function saveQuotesSelection(
  requestId: string,
  dto: SaveQuotesSelectionDto,
): Promise<{ updated: number }> {
  const res = await apiClient.post<{ success: true; data: { updated: number } }>(
    `/requests/${requestId}/quotes-selection`,
    dto,
  )
  return res.data.data
}

/** Read-only сводка квот для закупщика. С 22.05.2026. На бэке:
 *  фильтр sourceType ∈ {CHINA, MANUFACTURER} + supplierName !== «Цена менеджера».
 *  min считается только среди видимых квот. selectedQuoteId всегда null.
 *  clientName всегда пустой — закупщикам имя заказчика не показываем (23.05). */
export interface QuotesOverviewResponse extends QuotesSummaryResponse {
  readOnly: true
  request: QuotesSummaryResponse['request'] & { clientCode: string | null }
}

export async function getQuotesOverview(requestId: string): Promise<QuotesOverviewResponse> {
  const res = await apiClient.get<{ success: true; data: QuotesOverviewResponse }>(
    `/requests/${requestId}/quotes-overview`,
  )
  return res.data.data
}
